import { take } from 'redux-saga/effects'

import { types as LifecycleTypes } from '../../actions'

export default {
    [LifecycleTypes.DIRECT_LINK_PROMPT]: [
        {
            event: 'pico.prompt.shown',
            * data() {
                yield take(LifecycleTypes.PICO_LOADED)
                return { detail: { source: 'direct_link' } }
            },
        },
    ],
    [LifecycleTypes.PLAN_LINK_PROMPT]: [
        {
            event: 'pico.prompt.shown',
            data() {
                return { detail: { source: 'plan_link' } }
            },
        },
    ],
    [LifecycleTypes.LAUNCHER_PROMPT]: [
        {
            event: 'pico.prompt.shown',
            data() {
                return { detail: { source: 'launcher_prompt' } }
            },
        },
    ],
    [LifecycleTypes.POPUP_PROMPT]: [
        {
            event: 'pico.prompt.shown',
            data() {
                return { detail: { source: 'popup_prompt' } }
            },
        },
    ],
}
